import React from 'react'
import { ucFirst } from '../../../helpers/string_helper'
import { Modules } from '../../../constants/Module'
import { Action } from '../../../constants/Common'
import CreatorDetails from '../../../pages/ChangeRequest/activities/creatorDetails'
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { DeliverableStatus, TicketStatuses } from '../../../constants/Status'
import { withTranslation } from 'react-i18next'
function Task({ item, t }) {
  return (
    <div>
        <div>
            <strong> {ucFirst(Modules.TASK)} ({typeof item?.payload?.name === 'object' ? item?.payload?.name.old : item?.payload?.name}) </strong>
             {item.event === Action.CREATE ? t('was added to') : item.event === Action.UPDATE ? t('was updated for') : t('was deleted from')}  <strong>{t('startup')} {ucFirst(item.project.name)} ({item?.project?.uniqueProjectId})</strong> {t('by')} 
            <CreatorDetails creator={item?.creator} date={item?.createdAt} />
        </div>
        {item?.event === Action?.UPDATE && (
        <div>
            {item?.payload?.status &&
            item?.payload?.status?.old &&
            item?.payload?.status?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Status')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.status?.old?.name}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.status?.new?.name}</span>
                  </div>
                </div>
              </div>
            )}
          {typeof item?.payload?.name === 'object' &&
            item?.payload?.name?.old &&
            item?.payload?.name?.new && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong> {t('Name')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.name?.old}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.name?.new}</span>
                  </div>
                </div>
              </div>
            )}
          {item?.payload?.description && typeof item?.payload?.description === "object" && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Description')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.description?.old ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.description?.new ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.priority && 
          item?.payload?.priority?.old?.name && item?.payload?.priority?.new?.name && (
            <div className="mx-2">
              <div className="d-flex align-items-center change_status">
                <strong> {t('Priority')}:</strong>
                <div className="d-flex align-items-center mx-2">
                  <span>{item?.payload?.priority?.old?.name ?? "N/A"}</span>
                </div>
                <span className="middleArrow mx-2">
                  <ArrowRightAltOutlinedIcon />
                </span>
                <div className="d-flex align-items-center">
                  <span className="mx-2">
                    {item?.payload?.priority?.new?.name ?? "N/A"}
                  </span>
                </div>
              </div>
            </div>
          )}
          {item?.payload?.assignee && typeof item?.payload?.assignee === "object" && (
              <div className="mx-2">
                <div className="d-flex align-items-center change_status">
                  <strong>{t('Assignee')}: </strong>
                  <div className="d-flex align-items-center mx-2">
                    <span>{item?.payload?.assignee?.old?.name ?? 'N/A'}</span>
                  </div>
                  <span className="middleArrow mx-2">
                    <ArrowRightAltOutlinedIcon />
                  </span>
                  <div className="d-flex align-items-center">
                    <span className="mx-2">{item?.payload?.assignee?.new?.name ?? 'N/A'}</span>
                  </div>
                </div>
              </div>
            )}
          
        </div>
      )}
        
    </div>
  )
}
export default withTranslation()(Task)